import { useCallback, useEffect } from 'react';
import { App } from 'antd';

import { useAppDispatch, useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { setSelectedRows } from '../../../../common/store/selectionSlice';
import { useDeleteBroadcastMutation } from '../service/broadcasts.api';

export const useDelete = () => {
    const { notification } = App.useApp();
    const dispatch = useAppDispatch();
    const current = useAppSelector(selectShopCurrent);

    const [deleteBroadcasts, { error, isError, isLoading, isSuccess, reset }] =
        useDeleteBroadcastMutation();

    const clearSelection = useCallback(() => {
        dispatch(setSelectedRows([]));
    }, [dispatch]);

    useEffect(() => {
        const actionsMap: Record<string, () => void> = {
            isSuccess: () => {
                notification.success({
                    message: 'Рассылка успешно удалена',
                    placement: 'top',
                });
                clearSelection();
                reset();
            },
            isError: () => {
                notification.error({
                    message: 'Нельзя удалить рассылку',
                    description:
                        'error' in error ? error.error : '' || undefined,
                    placement: 'top',
                });
                clearSelection();
                reset();
            },
        };

        if (isSuccess) actionsMap.isSuccess();
        if (isError) actionsMap.isError();
    }, [isSuccess, isError, notification, clearSelection, reset, error]);

    const onBulkRemove = useCallback(
        async (ids: number[]): Promise<void> => {
            if (!current.id) return;
            for (const broadcast_id of ids) {
                try {
                    await deleteBroadcasts({
                        shop_id: +current.id,
                        broadcast_id,
                    }).unwrap();
                } catch {
                    break;
                }
            }
        },
        [current, deleteBroadcasts]
    );

    return { onBulkRemove, isLoading };
};
